<template>
  <v-slide-y-transition mode="out-in">
    <div id="coa-forms" style="margin-top: -20px">
      <v-container grid-list-xl fluid>
        <v-layout row wrap>
          <v-flex lg12>
          <v-card pa-0>
            <v-toolbar card color="white">              
              <v-text-field
              flat
              solo
              prepend-icon="search"
              placeholder="Type something"
              v-model="searchText"
              hide-details
              ></v-text-field>     
              <!--<v-btn icon>
                <v-icon>filter_list</v-icon>
              </v-btn>-->
              <v-btn color="success" dark @click="export2excel()">
                <v-icon left>select_all</v-icon> Download .xls
              </v-btn>                             
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text>
              <v-layout row wrap>
                <v-flex md3 xs6>
                  <v-menu                                 
                    ref="date_fr" lazy
                    v-bind:close-on-content-click="true"
                    transition="scale-transition"
                    offset-y full-width
                    v-bind:nudge-bottom="-22"                                                                  
                  >
                    <v-text-field box slot="activator" hide-details
                      label="Date From"
                      v-model="search.date_fr"
                      append-icon="event"
                      readonly clearable
                    ></v-text-field>
                    <v-date-picker v-model="search.date_fr" no-title scrollable></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex md3 xs6>
                  <v-menu                                 
                    ref="date_to" lazy
                    v-bind:close-on-content-click="true"
                    transition="scale-transition"
                    offset-y full-width
                    v-bind:nudge-bottom="-22"                                                                 
                  >
                    <v-text-field box slot="activator" hide-details
                      label="Date To"
                      v-model="search.date_to"
                      append-icon="event"
                      readonly clearable
                    ></v-text-field>
                    <v-date-picker v-model="search.date_to" no-title scrollable></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex md3 xs6>
                  <v-autocomplete                
                  box
                  v-model="toggle_status"
                  :items="status"
                  item-value="id"
                  item-text="name"
                  label="Select Status"
                  multiple                                   
                  hide-details
                ></v-autocomplete>
                </v-flex>
                <v-flex md3 xs6>
                  <v-autocomplete                
                  box
                  v-model="toggle_jalur"
                  :items="jalur"
                  item-value="id"
                  item-text="name"
                  label="Select Jalur"
                  multiple                                   
                  hide-details
                ></v-autocomplete>
                </v-flex>
                <v-flex md3 xs6>
                  <v-autocomplete                
                  box
                  v-model="toggle_paym"
                  :items="payments"
                  item-value="id"
                  item-text="name"
                  label="Select Payment"
                  multiple                                   
                  hide-details
                ></v-autocomplete>
                </v-flex>
                <v-flex md4 xs8>
                  <v-btn-toggle class="mr-3" v-model="toggle_gender" multiple dark>
                    <v-btn small flat class="red white--text" :value="1">L</v-btn>
                    <v-btn small flat class="blue-grey white--text"  :value="2">P</v-btn>              
                  </v-btn-toggle>              
                  <v-btn-toggle small v-model="toggle_tingkat" class="mr-3" multiple dark>                
                    <v-btn round small v-for="(tingkat,i) in tingkats" :key="i" :value="tingkat.id" :color="getColor(tingkat.id)">{{tingkat.nama}}</v-btn>                
                  </v-btn-toggle>  
                </v-flex>
                <v-flex md1 xs4>
                  <v-btn @click="init" style="float:right" color="primary">filter</v-btn>
                </v-flex>
                
              </v-layout>                                                        
            </v-card-text>
            <v-divider></v-divider>
            <v-card-text class="pa-0 tabular">
              <v-data-table
                id="journal"
                :headers="complex.headers"
                :search="searchText"
                :items="complex.items"
                :loading="loading"
                :pagination.sync="pagination"
                :rows-per-page-items="[{text:'All','value':-1},10,25,50]"
                class="elevation-1"
                item-key="id"                            
                v-model="complex.selected"
                >
                <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>  
                <template slot="items" slot-scope="props">
                  <td>{{ props.index+1 }}</td>                  
                  <td>{{props.item.id}}</td>
                  <td style="min-width:200px">{{ props.item.nama }}</td>
                  <td>{{props.item.gender === 1?'L':'P'}}</td>
                  <td v-if="tingkats.length > 0">{{ tingkats.find(x=>x.id===props.item.jurusan_id) ? tingkats.find(x=>x.id===props.item.jurusan_id).description : tingkats.find(x=>x.id===props.item.tingkat_id).description}}</td>                 
                  <td>{{props.item.calonGedung ? props.item.calonGedung.number : null}}</td>
                  <!--<td>{{props.item.calonGedung && props.item.calonGedung.gedung && props.item.calonGedung.ruang.nama ? props.item.calonGedung.gedung.nama + ' '+props.item.calonGedung.ruang.nama : null}}</td>-->                  
                  
                  <td>{{ props.item.lahir_tempat +', '+ $moment(props.item.lahir_tanggal).format('DD/MM/YYYY') }}</td>
                  <td v-if="status.length > 0">{{ status.find(x=>x.id===props.item.status) ? status.find(x=>x.id===props.item.status).name : null }}</td>
                  <td>
                    <span v-if="props.item.jalur_id == 1">REGULER</span>
                    <span v-else-if="props.item.jalur_id == 2">PRESTASI</span>
                    <span v-else-if="props.item.jalur_id == 3">UNDANGAN</span>                    
                  </td>
                  <td>
                    <span>{{props.item.lulus==1?'lulus':(props.item.lulus==-1?'tidaklulus':(props.item.lulus==2?'cadangan':''))}} 
                      <span v-if="props.item.tingkat_id==3">
                        @{{getLabelJurusan(props.item.jurusan_id)}}
                      </span>
                    </span><br/>
                    <span v-if="props.item.tingkat_id ==3 && props.item.lulus_jurusan && props.item.lulus_jurusan != props.item.jurusan_id">
                      lulus@{{getLabelJurusan(props.item.lulus_jurusan)}}
                    </span>
                  </td>
                  <td><small>{{ Array.isArray(payments) && props.item.payment ?payments.find(x=>x.id===props.item.payment.reff_type) ? payments.find(x=>x.id===props.item.payment.reff_type).name : null :null}}</small></td>
                  <td v-if="props.item.payment">{{props.item.payment.reff_number}}</td>
                  <td>{{$moment(props.item.created_at*1000).format('DD-MMMYY (HH:mm)')}}</td>
                  <td style="min-width:200px">{{props.item.sekolah_nama}}</td>
                  <td>{{props.item.sekolah_nis}}</td>
                  <td style="min-width:160px">{{props.item.sekolah_kecamatan_nama}}</td>
                  <td style="min-width:160px">{{props.item.sekolah_kota_nama}}</td>
                  <td style="min-width:160px">{{props.item.sekolah_provinsi_nama}}</td>
                  <td style="min-width:170px">{{props.item.ayah_nama}}</td>
                  <td>{{props.item.ayah_pekerjaan}}</td>
                  <td>{{props.item.ayah_penghasilan}}</td>
                  <td style="min-width:170px">{{props.item.ibu_nama}}</td>
                  <td>{{props.item.ibu_pekerjaan}}</td>
                  <td>{{props.item.ibu_penghasilan}}</td>
                  
                  <td>{{props.item.email}}</td>
                  <td>{{ props.item.telepon }}</td>  
                  <td>{{props.item.whatsapp}}</td>
                  <td>{{props.item.pengeluaran}}</td>
                  <td style="min-width:300px">{{props.item.alamat}}</td>
                  <td style="min-width:160px">{{props.item.kelurahan_nama}}</td>
                  <td style="min-width:160px">{{props.item.kecamatan_nama}}</td>
                  <td style="min-width:160px">{{props.item.kota_nama}}</td>
                  <td style="min-width:160px">{{props.item.provinsi_nama}}</td>
                  <td>{{props.item.test.quran1}}</td>
                  <td>{{props.item.test.quran2}}</td>
                  <td class="text-xs-left" style="min-width:150px">
                    <router-link :to="{path:viewPath, query: {id: props.item.user_id}}">
                      <v-btn depressed icon class="primary--text" small>
                        <v-icon>find_in_page</v-icon>
                      </v-btn>
                    </router-link>          
                    <router-link :to="{path:cardPath, query: {id: props.item.user_id}}" v-if="props.item.status >= 3 && props.item.tingkat_id !== 1">
                      <v-btn depressed icon class="primary--text" small>
                        <v-icon>local_offer</v-icon>
                      </v-btn>
                    </router-link>
                  </td>
                </template>
              </v-data-table>
            </v-card-text>            
          </v-card>
        </v-flex>                           
        </v-layout>
      </v-container>
    </div>
  </v-slide-y-transition>
</template>

<script>  
import Table2Excel from 'table2excel.js';  
import Model from '@/apps/admin/models/Calon';   

var model = new Model();

export default {
    $_veeValidate: {
      validator: 'new'
    },    
    data: () => ({
        formPath : '/calon/form',
        viewPath : '/calon/view',
        cardPath : '/calon/card',
        searchText   : '',
        loading  : false,
        toggle_tingkat : [],
        toggle_gender : [],
        toggle_status : [],
        toggle_paym : [],
        toggle_jalur : [],
        search:{date_fr :null, date_to:null},
        pagination: {},
        complex  : {
            selected: [],
            headers: [
              { text: '#',   value: 'no'  },  
              { text: 'Id',   value: 'id'  },  
              { text: 'Nama', value: 'nama'},  
              { text: 'Gen', value: 'gender'},
              { text: 'Tingkat', value: 'tingkat_id'},  
              { text: 'Nomor', value: 'calonGedung.number'},
              //{ text: 'Ruang Ujian', value: 'calonGedung.ruang.nama'},                                       
              { text: 'Tempat/Tgl Lahir', value:'tempat_lahir'},
              { text: 'Status', value:'status'},
              { text: 'Jalur', value:'jalur'},
              { text: 'Kelulusan', value:'lulus'},
              { text: 'Payment Method', value:'payment.reff_type'},
              { text: 'Payment Reff', value:'payment.reff_number'},
              { text: 'Created', value:'created_at' },
              { text: 'Sekolah Asal',   value: 'sekolah_nama'  },
              { text: 'NIS',   value: 'sekolah_nis'  },
              { text: 'Sekolah Kecamatan',   value: 'sekolah_kecamatan_nama'  },
              { text: 'Sekolah Kota/Kab',   value: 'sekolah_kota_nama'  },              
              { text: 'Sekolah Provinsi',   value: 'sekolah_provinsi_nama'  },              
              { text: 'Nama Ayah',   value: 'ayah_nama'  },
              { text: 'Pekerjaan Ayah',   value: 'ayah_pekerjaan'  },
              { text: 'Penghasilan Ayah',   value: 'ayah_penghasilan'  },
              { text: 'Nama Ibu',   value: 'ibu_nama'  },
              { text: 'Pekerjaan Ibu',   value: 'ibu_pekerjaan'  },
              { text: 'Penghasilan Ibu',   value: 'ibu_penghasilan'  },              
              { text: 'email',   value: 'email'  },
              { text: 'Telepon', value: 'telepon'}, 
              { text: 'Whatsapp',   value: 'whatsapp'  },
              { text: 'Pengeluaran',   value: 'pengeluaran'  },
              { text: 'Alamat',   value: 'alamat'  },
              { text: 'Kelurahan',   value: 'kelurahan.nama'  },
              { text: 'Kecamatan',   value: 'kecamatan.nama'  },
              { text: 'Kota/Kabupaten',   value: 'kota.nama'  },
              { text: 'Provinsi',   value: 'provinsi.nama'  },
              { text: 'QuranTes1',   value: 'test.quran1'  },
              { text: 'QuranTes2',   value: 'test.quran2'  },
              { text: 'Action', value: '', align:'center' },              
            ],
            items: []
        },
        loadingDownload : false,
        tingkats : [],
        status   : [],
        types : [],
        jalur : [{id:1, name:'Reguler'}, {id:2, name:'Prestasi'},{id:3,name:'Undangan'}],
        payments:[],
    }),  
    watch:{
      toggle_tingkat(newArr){
        let tingkat = [], jurusan = [];
        newArr.forEach(ar=>{
          if(ar <= 3){tingkat.push(ar);} 
          else if(ar === 7){tingkat.push(ar);}
          else{jurusan.push(ar);}
        });
        this.loading = true;
        this.complex.items = [];
        model.indexRekap({
          'UserCalonSearch[status]':this.toggle_status,
          'UserCalonSearch[gender]':this.toggle_gender,
          'UserCalonSearch[tingkat_id]':tingkat,
          'UserCalonSearch[jurusan_id]':jurusan,
          'UserCalonSearch[paym]':this.toggle_paym,
          'UserCalonSearch[date_fr]':this.search.date_fr,
          'UserCalonSearch[date_to]':this.search.date_to,
          'UserCalonSearch[jalur_id]':this.toggle_jalur,
        }).then(data => {      
          this.complex.items = data; 
          this.loading = false;
        }); 
      },
      toggle_gender(newArr){
        let tingkat = [], jurusan = [];
        this.toggle_tingkat.forEach(ar=>{
          if(ar <= 3){tingkat.push(ar);} 
          else if(ar === 7){tingkat.push(ar);}
          else{jurusan.push(ar);}
        });
        this.loading = true;
        this.complex.items = [];
        model.indexRekap({
          'UserCalonSearch[status]':this.toggle_status,
          'UserCalonSearch[gender]':newArr,
          'UserCalonSearch[tingkat_id]':tingkat,
          'UserCalonSearch[jurusan_id]':jurusan,
          'UserCalonSearch[paym]':this.toggle_paym,
          'UserCalonSearch[date_fr]':this.search.date_fr,
          'UserCalonSearch[date_to]':this.search.date_to,
          'UserCalonSearch[jalur_id]':this.toggle_jalur,
        }).then(data => {      
          this.complex.items = data; 
          this.loading = false;
        }); 
      },
      toggle_status(newArr){
        let tingkat = [], jurusan = [];
        this.toggle_tingkat.forEach(ar=>{
          if(ar <= 3){tingkat.push(ar);} 
          else if(ar === 7){tingkat.push(ar);}
          else{jurusan.push(ar);}
        });
        this.loading = true;
        this.complex.items = [];
        model.indexRekap({
          'UserCalonSearch[status]':newArr,
          'UserCalonSearch[gender]':this.toggle_gender,
          'UserCalonSearch[tingkat_id]':tingkat,
          'UserCalonSearch[jurusan_id]':jurusan,
          'UserCalonSearch[date_fr]':this.search.date_fr,
          'UserCalonSearch[date_to]':this.search.date_to,
          'UserCalonSearch[paym]':this.toggle_paym,
          'UserCalonSearch[jalur_id]':this.toggle_jalur
        }).then(data => {      
          this.complex.items = data; 
          this.loading = false;
        }); 
      },
      toggle_paym(newArr){
        let tingkat = [], jurusan = [];
        this.toggle_tingkat.forEach(ar=>{
          if(ar <= 3){tingkat.push(ar);} 
          else if(ar === 7){tingkat.push(ar);}
          else{jurusan.push(ar);}
        });
        this.loading = true;
        this.complex.items = [];
        model.indexRekap({
          'UserCalonSearch[status]':this.toggle_status,
          'UserCalonSearch[gender]':this.toggle_gender,
          'UserCalonSearch[tingkat_id]':tingkat,
          'UserCalonSearch[jurusan_id]':jurusan,
          'UserCalonSearch[jalur_id]':this.toggle_jalur,
          'UserCalonSearch[date_fr]':this.search.date_fr,
          'UserCalonSearch[date_to]':this.search.date_to,
          'UserCalonSearch[paym]':newArr,
        }).then(data => {      
          this.complex.items = data; 
          this.loading = false;
        }); 
      },
      search:{
        handler(newObj){          
          let tingkat = [], jurusan = [];
          this.toggle_tingkat.forEach(ar=>{
            if(ar <= 3){tingkat.push(ar);} 
            else if(ar === 7){tingkat.push(ar);}
            else{jurusan.push(ar);}
          });
          this.loading = true;
          this.complex.items = [];
          model.indexRekap({
            'UserCalonSearch[status]':this.toggle_status,
            'UserCalonSearch[gender]':this.toggle_gender,
            'UserCalonSearch[tingkat_id]':tingkat,
            'UserCalonSearch[jurusan_id]':jurusan,
            'UserCalonSearch[jalur_id]':this.toggle_jalur,
            'UserCalonSearch[date_fr]':newObj.date_fr,
            'UserCalonSearch[date_to]':newObj.date_to,
            'UserCalonSearch[paym]':this.toggle_paym,
          }).then(data => {      
            this.complex.items = data; 
            this.loading = false;
          });
        }, deep:true
      },
    },
    mounted(){ 
      model.tingkats().then(data=>{this.tingkats = data});
      model.status().then(data=>{this.status = data});
      model.paymentTypes().then(data=>{this.types = data});
      model.settings({key:'payment_method'}).then(res=>{
        this.payments = res.value;
      });
      //this.init(); 
    },            
    methods: {      
        format(tgl) { return this.$moment(tgl).format('DD-MM-YYYY')},
        
        getColor(tingkat){
          switch(tingkat){case 1:return 'red darken-2'; case 2: return 'indigo'; case 3:return 'blue-grey'; case 7:return 'light-green'; default:return 'blue-grey';}
        },
        
        getLabelJurusan(jurusan_id=null){          
          switch(jurusan_id){
            case 4: return 'IPA';
            case 5: return 'IPS';
            case 6: return 'AGAMA';
            default: return '';
          }
        },

        init(){
            if(this.$route.query.flag){ 
                Object.assign(this.pagination, {sortBy : 'flag', descending:true});
            }            

            let tingkat = [], jurusan = [];
            this.toggle_tingkat.forEach(ar=>{
              if(ar <= 3){tingkat.push(ar);} 
              else if(ar === 7){tingkat.push(ar);}
              else{jurusan.push(ar);}
            });

            this.complex.items = [];
            this.loading = true;
            model.indexRekap({
              'UserCalonSearch[status]':this.toggle_status,
              'UserCalonSearch[gender]':this.toggle_gender,
              'UserCalonSearch[tingkat_id]':tingkat,
              'UserCalonSearch[jurusan_id]':jurusan,
              'UserCalonSearch[date_fr]':this.search.date_fr,
              'UserCalonSearch[date_to]':this.search.date_to,
              'UserCalonSearch[paym]':this.toggle_paym,
              'UserCalonSearch[jalur_id]':this.toggle_jalur,
            }).then(data => {      
                this.complex.items = data; 
                this.loading = false;
            });                                         
        },        
        
        export2excel(){
            if(this.complex.items.length !== 0){
                var filename = 'Rekap.';            
                filename    += this.$moment().format('DDMMYY.HHmm');
                new Table2Excel('#journal table').export(filename);
            } else {
                window.getApp.$emit('showSnackbar', {
                    show : true,
                    text : 'No Data Result',
                    color: 'orange'
                });
            }
        },
    }
}
</script>
<style>
.tabular table.v-table tbody td:first-child, .tabular table.v-table tbody td:not(:first-child), .tabular table.v-table tfoot td:first-child, .tabular table.v-table tfoot td:not(:first-child), .tabular table.v-table tbody th:first-child, .tabular table.v-table tbody th:not(:first-child), .tabular table.v-table thead td:first-child, .tabular table.v-table thead td:not(:first-child), .tabular table.v-table thead th:first-child, .tabular table.v-table thead th:not(:first-child) {
    padding: 0 4px;
}
.tabular table.v-table tbody td:first-child, .tabular table.v-table thead th:first-child{
    padding: 0 7px 0 15px
}
</style>